import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Highcharts from "highcharts/highstock";
import { initModule } from "../../utils/utility";
import HighchartsReact from "highcharts-react-official";
import Loader from "../Loader";
import * as ExportingModule from "highcharts/modules/exporting";
import * as ExportDataModule from "highcharts/modules/export-data";
import NoData from "../Nodata";
import { createChartOptions, CHART_TITLE } from "./constants";

// 3. Initialize
initModule(ExportingModule);
initModule(ExportDataModule);

const LineBarComposedChart = ({ data = {}, loading = false, energyConsumptionData = [] }) => {
  const chartComponentRef = useRef(null);
  const options = createChartOptions(data, energyConsumptionData);

  useEffect(() => {
    if (chartComponentRef.current) {
      chartComponentRef.current.chart.reflow();
    }
  }, [data, energyConsumptionData]);

  const hasData = (data?.setpointPower?.length ?? 0) > 0 || (energyConsumptionData?.length ?? 0) > 0;

  return (
    <div className="relative w-full" style={{ height: "70%", marginBottom: 20 }}>
      <div style={{ color: "#333", fontWeight: "bold", fontSize: "16px" }}>{CHART_TITLE}</div>
      {!loading && !hasData ? (
        <NoData />
      ) : loading ? (
        <div
          className="absolute inset-0 z-10 flex items-center justify-center"
          style={{
            backgroundColor: "rgba(255,255,255,0.7)",
            height: data && hasData ? undefined : "100%",
          }}
        >
          <Loader />
        </div>
      ) : (
        <HighchartsReact highcharts={Highcharts} options={options} ref={chartComponentRef} />
      )}
    </div>
  );
};

LineBarComposedChart.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  energyConsumptionData: PropTypes.array,
};

export default LineBarComposedChart;
